import { Button } from '@factorialco/deprecated-design-system'
import { SecuritySettingsDomainSectionFragment } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  domain: SecuritySettingsDomainSectionFragment
  onClose: () => void
  onDelete: () => void
}

export const DeleteDomainModal = ({ domain, onClose, onDelete }: Props) => {
  return (
    <Modal
      illustration="alert"
      title={i18n.t('security_settings.domain.delete.title')}
      description={i18n.t('security_settings.domain.delete.description', {
        domainName: domain.domainName,
      })}
      onSubmit={() => {}}
      onClose={onClose}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button onClick={() => onDelete()} submit>
            {i18n.t('security_settings.domain.delete.submit')}
          </Button>
        </>
      }
    ></Modal>
  )
}
